// extracted by mini-css-extract-plugin
export default {"errorPageWrapper":"errorPages_errorPageWrapper__9uJlc","errorPageLink":"errorPages_errorPageLink__GZdYx"};